export default {
	biddingFrozen: {
		description: 'Please speak to an admin to reactivate this.',
		title: {
			PROXY: 'Bidding disabled',
			SALE: 'Purchasing disabled',
		},
	},
	otherContactHasBidOrOffered: {
		description: {
			PROXY: 'Someone else at your dealership has already bid on this vehicle.',
			SALE: 'Someone else at your dealership has already made an offer on this vehicle.',
		},
		title: {
			PROXY: 'Bidding unavailable',
			SALE: 'Purchasing unavailable',
		},
	},
	placeBidKycAfterSubmit: {
		description: 'Our team is reviewing your company information and will contact you soon.',
		title: 'Bidding unavailable',
	},
	placeBidKycBeforeSubmit: {
		buttonText: 'Go to company information',
		description:
			'To have full access to the Motorway platform and be able to bid on vehicles, you need to complete and submit your company information',
		title: 'Bidding unavailable',
	},
	userHasBidOrOffered: {
		cancelButton: {
			PROXY: 'Cancel bid',
			SALE: 'Cancel offer',
		},
		cancellation: {
			failure: {
				PROXY: 'There was an error cancelling your bid.',
				SALE: 'There was an error cancelling your offer.',
			},
			success: {
				PROXY: 'Your bid was cancelled.',
				SALE: 'Your offer was cancelled.',
			},
		},
		cancellationModal: {
			eventAndToastLabel: {
				PROXY: 'bid',
				SALE: 'offer',
			},
		},
		description: 'Cancel',
		title: {
			PROXY: 'Your bid: {amount}',
			SALE: 'Your offer: {amount}',
		},
	},
};
